module.exports = __webpack_public_path__ + "static/mobile-d7dc1299c2077fce68678a3e2aaa6bb7.svg";